import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { ApiResponse } from "@/utils/ApiResponse";
import { useToast } from "vue-toastification";
import { ModeloVehiculoCreateInterface } from "../../interfaces/modelovehiculosinterfaces/ModeloVehiculoCreate.interface";
import { UpdateModeloVehiculoAction } from "../../actions/modeloVehiculoActions";
import { ModelosVehiculoInterface } from "../../interfaces/modelovehiculosinterfaces/ModeloVehiculo.interface";

const toast = useToast();

interface UpdateModelo {
  idModelo: string;
  Modelo: ModeloVehiculoCreateInterface;
}

export function useModeloVehiculoUpdate(onClose?: () => void) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ idModelo, Modelo }: UpdateModelo) =>
      UpdateModeloVehiculoAction(idModelo, Modelo),

    onSuccess: async (
      response: ApiResponse<ModelosVehiculoInterface>,
      variables
    ) => {
      // ðŸ‘‡ Remover el cachÃ© especÃ­fico antes de invalidar
      queryClient.removeQueries({
        queryKey: ["ModeloVehiculoFindOne", variables.idModelo],
      });

      // Invalidar la lista
      await queryClient.invalidateQueries({
        queryKey: ["ModeloVehiculosList"],
      });
      await queryClient.refetchQueries({
        queryKey: ["MarcaModeloList"],
        exact: true,
      });
      toast.success("Modelo de vehÃ­culo actualizado correctamente");

      if (onClose) onClose();
    },

    onError: (error: unknown) => {
      toast.error("Error al actualizar modelo de vehÃ­culo");
      if (onClose) onClose();
    },
  });

  return {
    ...mutation,
  };
}
